var map = {
	"./game-bankvault/theme": "0c76",
	"./game-brainstorm/theme": "88e3",
	"./game-faces/theme": "c30b",
	"./game-shopping/theme": "62bb",
	"./game-timemachine/theme": "b9ca",
	"./game-vocabguru/theme": "1547"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e3f";